import React, { useState } from "react";
import { Button } from "../ButtonElements";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import {
  InfoContainer,
  InfoWrapper,
  InfoRow,
  Column1,
  Column2,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  BtnWrap,
  Img,
  ImgWrap,
} from "./InfoElements";

import AppDownloadModal from "./AppDownloadModal";
import ExternalLinkModal from "./ExternalLinkModal";

// Helper function to render the button
const renderButton = ({
  buttonLabel,
  setShowSignupModal,
  setShowExternalModal,
  primary,
  dark,
  dark2,
  isSignUp,
  isExternalLink,
}) => {
  if (isExternalLink) {
    return (
      <Button
        onClick={() => setShowExternalModal(true)}
        primary={primary ? 1 : 0}
        dark={dark ? 1 : 0}
        dark2={dark2 ? 1 : 0}
      >
        {buttonLabel}
      </Button>
    );
  }

  if (isSignUp) {
    return (
      <Button
        onClick={() => setShowSignupModal(true)}
        primary={primary ? 1 : 0}
        dark={dark ? 1 : 0}
        dark2={dark2 ? 1 : 0}
      >
        {buttonLabel}
      </Button>
    );
  }

  return null;
};

const InfoSection = ({
  lightBg,
  id,
  imgStart,
  topLine,
  lightText,
  headline,
  darkText,
  description,
  buttonLabel,
  img,
  alt,
  primary,
  dark,
  dark2,
  isRTL,
}) => {
  const [showSignupModal, setShowSignupModal] = useState(false);
  const [showExternalModal, setShowExternalModal] = useState(false);
  const { t } = useTranslation();

  const showButton = buttonLabel !== t("about.buttonLabel");
  const isExternalLink = buttonLabel === t("discover.buttonLabel");
  const isSignUp = buttonLabel === t("signup.buttonLabel");

  return (
    <>
      <InfoContainer lightBg={lightBg} id={id} className={isRTL ? "arabe" : ""}>
        <InfoWrapper>
          <InfoRow imgStart={imgStart}>
            <Column1 data-aos="fade-right">
              <TextWrapper>
                <TopLine>{topLine}</TopLine>
                <Heading lightText={lightText}>{headline}</Heading>
                <Subtitle darkText={darkText}>{description}</Subtitle>
                <BtnWrap>
                  {showButton &&
                    renderButton({
                      buttonLabel,
                      setShowSignupModal,
                      setShowExternalModal,
                      primary,
                      dark,
                      dark2,
                      isSignUp,
                      isExternalLink,
                    })}
                </BtnWrap>
              </TextWrapper>
            </Column1>
            <Column2 data-aos="fade-left">
              <ImgWrap>
                <Img isRTL={isRTL} src={img} alt={alt} />
              </ImgWrap>
            </Column2>
          </InfoRow>
        </InfoWrapper>
      </InfoContainer>

      {/* Modals */}
      <AppDownloadModal
        show={showSignupModal}
        onHide={() => setShowSignupModal(false)}
        t={t}
      />

      <ExternalLinkModal
        show={showExternalModal}
        onHide={() => setShowExternalModal(false)}
        t={t}
        primary={primary}
        dark={dark}
        dark2={dark2}
      />
    </>
  );
};

InfoSection.propTypes = {
  lightBg: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  imgStart: PropTypes.bool,
  topLine: PropTypes.string,
  lightText: PropTypes.bool,
  headline: PropTypes.string,
  darkText: PropTypes.bool,
  description: PropTypes.string,
  buttonLabel: PropTypes.string,
  img: PropTypes.string,
  alt: PropTypes.string,
  primary: PropTypes.bool,
  dark: PropTypes.bool,
  dark2: PropTypes.bool,
  isRTL: PropTypes.bool,
};

export default InfoSection;
